const SAFE_HEIGHT_RATIO = 0.7;

export function isNoteHeightSafe(container: HTMLDivElement) {
	const noteHeight = container.offsetHeight;
	const contentHeight = Mapy.getComponent("layout").getContent().offsetHeight;
	const isSafe = noteHeight / contentHeight < SAFE_HEIGHT_RATIO;

	return isSafe;
}
